import { Flex } from '@amzn/storm-ui';
import { Form } from '@amzn/storm-ui-column-form-kit';
import { useTranslation } from 'react-i18next';
import { CustomCard } from '../../../UiComponentsLibrary/CustomCard';
import { CustomButton } from '../../../UiComponentsLibrary/CustomButton';
import { CustomButtonColor } from '../../../UiComponentsLibrary/CustomButton/constants/CustomButtonColor';
import {
  CustomSnackbar,
  SnackbarVariants,
} from '../../../UiComponentsLibrary/CustomSnackbar';
import { DatePickerConfig } from './constants/interfaces';
import { FormInputField } from '../FormInputField/FormInputField';
import DatePickerWrapper from './DatePickerWrapper';
import { useCreateArtEventForm } from './hook/useCreateArtEventForm';
import { datePickerConfigs } from './constants/configs';
import { WaitlistToggleField } from '../WaitlistToggleField';

const CreateArtEvent = () => {
  const { t } = useTranslation();
  const {
    dateProps,
    errorProps: { showError, setShowError },
    mutationProps: { createArtEventMutation },
    buttonProps: { handleSubmit, handleCancel },
    successProps: { showSuccess, setShowSuccess },
    artEventProps: { artEventName, handleArtEventNameChange },
    validationProps: { validationErrors },
    waitlistProps: { waitlistEnabled, setWaitlistEnabled, waitlistFeatureEnabled },
  } = useCreateArtEventForm();

  const errorMessage = createArtEventMutation.error
    ? t('art-event-create-error')
    : '';

  const technicalDetails = createArtEventMutation.error?.message;

  return (
    <>
      <CustomSnackbar
        id="art-event-create-error-snackbar"
        variant={SnackbarVariants.ERROR}
        message={errorMessage}
        isVisible={showError}
        onClose={() => setShowError(false)}
        technicalDetails={technicalDetails}
      />
      <CustomSnackbar
        id="art-event-create-success-snackbar"
        variant={SnackbarVariants.SUCCESS}
        message={t('art-event-create-success')}
        isVisible={showSuccess}
        onClose={() => setShowSuccess(false)}
      />
      <CustomCard
        id="create-art-event-card"
        title={t('create-art-event-title')}
      >
        <Form id="create-art-event-form">
          <FormInputField
            id="art-event-name"
            label={t('art-event-name-label')}
            value={artEventName}
            onChange={handleArtEventNameChange}
            placeholder={t('enter-art-event-name-placeholder')}
            error={validationErrors.artEventName}
          />
          {datePickerConfigs.map((config: DatePickerConfig, index) => (
            <DatePickerWrapper
              config={config}
              index={index}
              key={config.id}
              {...dateProps}
              validationErrors={validationErrors}
            />
          ))}
          {waitlistFeatureEnabled && (
            <WaitlistToggleField
              id="create-art-event-waitlist-toggle"
              enabled={waitlistEnabled}
              onToggle={setWaitlistEnabled}
              showOptionalNote
            />
          )}
        </Form>
        <Flex justifyContent="flex-end" padding="xsmall" columnGap="small">
          <CustomButton
            id="create-art-event-cancel-button"
            text={t('cancel-button')}
            backgroundColor={CustomButtonColor.cancel}
            handleOnClickCb={handleCancel}
          />
          <CustomButton
            id="create-art-event-submit-button"
            text={t('submit-button')}
            backgroundColor={CustomButtonColor.submit}
            handleOnClickCb={handleSubmit}
            disabled={createArtEventMutation.isPending}
          />
        </Flex>
      </CustomCard>
    </>
  );
};

export default CreateArtEvent;
